import React, { useState } from "react";
import {
  Box,
  Typography,
  Slider,
  TextField,
  Button,
  Dialog,
  DialogContent,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import RateReviewIcon from "@mui/icons-material/RateReview";

export default function AutoEvaluationDialog({ open, onSubmit, onCancel }) {
  const [rating, setRating] = useState(2.5);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation("pitch");

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    await onSubmit({ rating, comment });
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
    //   scroll="body"
      PaperProps={{
        sx: {
          background: "transparent",
          boxShadow: "none",
        //   overflow: "visible",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            backgroundColor: "#212121dd",
            color: "#fff",
            borderRadius: 4,
            px: 2,
            py: 2.5,
            maxWidth: 560,
            width: "100%",
            textAlign: "center",
            mx: "auto",
            boxShadow: "0 0 30px rgba(0,0,0,0.6)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              mb: 1,
            }}
          >
            <RateReviewIcon sx={{ color: "#a855f7" }} />
            <Typography variant="h5">{t("auto_eval.title")}</Typography>
          </Box>

          <Typography sx={{ mt: 3, mb: 0 }}>
            {t("auto_eval.rating_label")}
          </Typography>
          <Typography  variant="body2" color="text.secondary" sx={{ mt: 1, mb: 0 }}>
            {t("auto_eval.rating_label2")}
          </Typography>

          <Slider
            value={rating}
            min={0}
            max={5}
            step={0.5}
            marks
            valueLabelDisplay="auto"
            onChange={(e, val) => setRating(val)}
            sx={{
              color: "#a855f7",
              mt: 1,
              height: 10, // altura del slider
              '& .MuiSlider-track': {
                height: 10,
                borderRadius: 2,
              },
              '& .MuiSlider-rail': {
                height: 10,
                borderRadius: 2,
              },
              '& .MuiSlider-thumb': {
                height: 24,
                width: 24,
                backgroundColor: "#fff",
                border: "2px solid currentColor",
                '&:hover': {
                  boxShadow: "0px 0px 0px 8px rgba(168, 85, 247, 0.16)",
                },
              },
            }}
          />

          <TextField
            label={t("auto_eval.comment_label")}
            multiline
            fullWidth
            rows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            inputProps={{ maxLength: 500 }}
            sx={{
              mt: 3,
              "& .MuiInputBase-root": {
                color: "#fff",
                backgroundColor: "#121212",
              },
              "& .MuiInputLabel-root": { color: "#aaa" },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#555",
              },
            }}
          />
          <Typography sx={{ mt: 1, fontSize: 13, color: "#aaa", textAlign: "right" }}>
            {comment.length}/500
          </Typography>

          <Box mt={4} display="flex" justifyContent="space-between">
            <Button
              onClick={onCancel}
              variant="text"
              sx={{
                color: "#ccc",
                fontWeight: 600,
                "&:hover": { color: "#76ff03" },
              }}
            >
              {t("auto_eval.cancel")}
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={submitting}
              variant="contained"
              sx={{
                backgroundColor: "#a855f7",
                fontWeight: 600,
                borderRadius: 999,
                px: 4,
                py: 1.2,
                "&:hover": { backgroundColor: "#9333ea" },
                "&.Mui-disabled": {
                  backgroundColor: "#6b21a8",
                  opacity: 0.7,
                },
              }}
            >
              {t("auto_eval.submit")}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
